import { render } from "./TheStatusBadge.vue?vue&type=template&id=41838b1c"
import script from "./TheStatusBadge.vue?vue&type=script&lang=js"
export * from "./TheStatusBadge.vue?vue&type=script&lang=js"

import "./TheStatusBadge.vue?vue&type=style&index=0&id=41838b1c&lang=css"

import exportComponent from "F:\\Softwaresul\\Projetos Node\\LWP\\Nil Key\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__